import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { configService, orderService, inventoryService, abonoService } from '../services/api';
import axios from 'axios';

const ESTADOS = ['Pendiente','En Taller','Lista','Entregada'];
const TIPOS_MUEBLE = ['Sofá', 'Sofá cama', 'Sala / Juego de sala', 'Sillón / Reclinable', 'Butaca', 'Diván', 'Cama', 'Melamina', 'Colchón', 'Comedor', 'Zapatera de Hombre', 'Zapatera de Mujer', 'Cojines', 'Bancos con Tela', 'Coqueta', 'Juego de Comedor', 'Especial'];
const TIPOS_SIN_TELA = ['Melamina', 'Colchón', 'Zapatera de Hombre', 'Zapatera de Mujer'];
const COLORS = { 'Pendiente':'#f59e0b','En Taller':'#3b82f6','Lista':'#8b5cf6','Entregada':'#10b981','Anulada':'#9ca3af' };
const fmtFecha = f => { if (!f) return "—"; const d = f.split("T")[0].split("-"); return parseInt(d[2])+"-"+parseInt(d[1])+"-"+d[0]; };
const fmt = n => n ? '₡' + Number(n).toLocaleString('es-CR') : '₡0';

const printStyles = `
  @media print {
    body > * { display: none !important; }
    .order-detail-print { display: block !important; position: static !important; background: white !important; max-height: none !important; overflow: visible !important; max-width: 100% !important; border: none !important; border-radius: 0 !important; padding: 20px !important; }
    .no-print { display: none !important; }
  }
`;

function DocView({ order, items, type, onClose, logoUrl, photos }) {
  const titles = { trabajo:'ORDEN DE TRABAJO', entrega:'ORDEN DE ENTREGA', factura:'FACTURA' };

  const handlePrint = () => {
    const el = document.querySelector('.print-area');
    if (!el) return;

    // Fotos solo en orden de trabajo
    let fotosHtml = '';
    if (type === 'trabajo' && photos && photos.length > 0) {
      const imgs = photos.map(p =>
        `<img src="${window.location.origin}/uploads/orders/${p.filename}" style="max-width:48%;max-height:90mm;object-fit:contain;border-radius:8px;border:1px solid #e0d0c0;" />`
      ).join('');
      fotosHtml = `
        <div style="margin-top:20px;">
          <div style="font-weight:700;font-size:13px;color:#5c3d2e;margin-bottom:10px;">📷 FOTOS DE REFERENCIA:</div>
          <div style="display:flex;flex-wrap:wrap;gap:10px;justify-content:center;align-items:flex-start;">${imgs}</div>
        </div>
      `;
    }

    const html = `<html><head><meta charset="utf-8"><style>
      body{font-family:Arial,sans-serif;font-size:16px;padding:0;margin:0;}
      table{width:100%;border-collapse:collapse;}
      th{background:#f5ede6;padding:8px 10px;text-align:left;font-size:15px;color:#5c3d2e;border-bottom:2px solid #e0d0c0;}
      td{padding:8px 10px;border-bottom:1px solid #f0e8e0;font-size:15px;vertical-align:top;} tr{page-break-inside:avoid;} thead{display:table-header-group;}
      .row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #f0e8e0;font-size:15px;}
      .label{color:#666;font-weight:600;}
      .value{font-weight:600;text-align:right;}
      .total{display:flex;justify-content:space-between;padding:12px 0;font-size:16px;font-weight:700;color:#5c3d2e;border-top:2px solid #5c3d2e;margin-top:8px;}
      img.logo{max-height:110px;object-fit:contain;}
      .no-print{display:none!important;}
      @page{margin:12mm;size:A4;}
      *{max-height:none!important;overflow:visible!important;}
    </style></head><body>${type === "factura" && logoUrl ? `<div style="display:grid;grid-template-columns:130px 1fr 130px;align-items:center;border-bottom:3px solid #5c3d2e;padding-bottom:14px;margin-bottom:18px;"><div><img src="${logoUrl}" style="height:100px;object-fit:contain;"/></div><div style="text-align:center;"><div style="font-size:22px;font-weight:900;color:#5c3d2e;">Muebles Terrasol</div><div style="font-size:13px;color:#555;margin-top:5px;">Tel: 7136-8383 / 7166-6393</div><div style="font-size:11px;color:#666;margin-top:3px;">San José, Guadalupe, 300 mts al este de la plaza de deporte de Mozotal</div></div><div style="text-align:right;"><div style="font-size:18px;font-weight:800;color:#5c3d2e;">FACTURA</div><div style="font-size:13px;font-weight:700;color:#a0522d;">${order.numero}</div></div></div>` : ""}${el.innerHTML}${fotosHtml}</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
    box: { background:'#fff', borderRadius:12, padding:32, maxWidth:600, width:'90%', maxHeight:'90vh', overflowY:'auto' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
    th: { background:'#f5ede6', padding:'8px 10px', textAlign:'left', fontWeight:700, fontSize:12, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0' },
    td: { padding:'8px 10px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'top' },
    total: { display:'flex', justifyContent:'space-between', padding:'12px 0', fontSize:16, fontWeight:700, color:'#5c3d2e', borderTop:'2px solid #5c3d2e', marginTop:8 },
  };

  const infoRows = {
    trabajo: [['N° Orden',order.numero],['Fecha Orden',fmtFecha(order.order_date)],['Fecha Entrega',fmtFecha(order.delivery_date)],['Vendedor',order.vendedor],['Observaciones',order.observations||'—']],
    entrega: [['N° Orden',order.numero],['Fecha Entrega',fmtFecha(order.delivery_date)],['Cliente',order.cliente_nombre],['Cédula',order.cedula||'—'],['Dirección',order.address||'—'],['Teléfono 1',order.phone1||'—'],['Teléfono 2',order.phone2||'—']],
    factura: [['N° Factura',order.numero],['Fecha',fmtFecha(order.order_date)],['Fecha Entrega',fmtFecha(order.delivery_date)],['Cliente',order.cliente_nombre],['Cédula',order.cedula||'—'],['Teléfono 1',order.phone1||'—'],['Teléfono 2',order.phone2||'—'],['Correo',order.email||'—'],['Dirección',order.address||'—']],
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div className="print-area" style={s.box} onClick={e=>e.stopPropagation()}>
        <div style={{ borderBottom:'3px solid #5c3d2e', paddingBottom:16, marginBottom:20, display: type === 'factura' ? 'none' : 'block' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              {logoUrl ? <img src={logoUrl} alt="Logo" className="logo" style={{ height:type==="factura"?110:52, objectFit:"contain", marginBottom:6 }}/> : <div style={{ fontSize:24, fontWeight:900, color:"#5c3d2e" }}>🪑 Muebles Terrasol</div>}
              {type === "factura" && <div style={{ fontSize:20, fontWeight:900, color:"#5c3d2e", marginTop:4 }}>Muebles Terrasol</div>}
              {type === "factura" && <div style={{ fontSize:12, color:"#555", marginTop:3 }}>Tel: 7136-8383 / 7166-6393</div>}
              {type === "factura" && <div style={{ fontSize:12, color:"#555", marginTop:2 }}>San José, Guadalupe, 300 mts al este de la plaza de deporte de Mozotal</div>}
              {type !== "factura" && <div style={{ color:"#888", fontSize:13 }}>Muebles Terrasol</div>}
              
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize:18, fontWeight:800, color:'#5c3d2e' }}>{titles[type]}</div>
              <div style={{ fontSize:13, fontWeight:700, color:'#a0522d' }}>{order.numero}</div>
            </div>
          </div>
        </div>
        {infoRows[type].map(([l,v]) => (
          <div key={l} style={s.row}><span style={{ color:'#666', fontWeight:600 }}>{l}</span><span style={{ fontWeight:600, maxWidth:'60%', textAlign:'right' }}>{v}</span></div>
        ))}

        {items && items.length > 0 && (
          <div style={{ marginTop:16 }}>
            <div style={{ fontWeight:700, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>ARTÍCULOS:</div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={s.th}>Artículo / Descripción</th>
                  <th style={{ ...s.th, textAlign:'center' }}>Cant.</th>
                  {type === 'factura' && <th style={{ ...s.th, textAlign:'right' }}>P. Unit.</th>}
                  {type === 'factura' && <th style={{ ...s.th, textAlign:'right' }}>Subtotal</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={idx}>
                    <td style={s.td}>
                      <div style={{ fontWeight:600 }}>{item.articulo}</div>
                      {(item.tipo || item.tela_catalogo) && <div style={{ color:'#5c3d2e', fontSize:12, marginTop:2 }}>{item.tipo ? 'Tipo: ' + item.tipo : ''}{item.tipo && item.tela_catalogo ? ' · ' : ''}{item.tela_catalogo ? 'Tela: ' + item.tela_catalogo + (item.tela_codigo ? ' (' + item.tela_codigo + ')' : '') : ''}</div>}
                      {item.descripcion && <div style={{ color:'#888', fontSize:12, marginTop:2 }}>{item.descripcion}</div>}
                    </td>
                    <td style={{ ...s.td, textAlign:'center' }}>{item.cantidad}</td>
                    {type === 'factura' && <td style={{ ...s.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>}
                    {type === 'factura' && <td style={{ ...s.td, textAlign:'right', fontWeight:600 }}>{fmt(item.subtotal)}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {type === 'factura' && (
          <div style={{ marginTop:8 }}>
            <div style={s.row}><span style={{ color:'#666', fontWeight:600 }}>Subtotal artículos</span><span style={{ fontWeight:600 }}>{fmt(order.amount)}</span></div>
            <div style={s.row}><span style={{ color:'#666', fontWeight:600 }}>Envío</span><span style={{ fontWeight:600 }}>{fmt(order.shipping)}</span></div>
            <div style={s.total}><span>TOTAL</span><span>{fmt(Number(order.amount)+Number(order.shipping))}</span></div>
          </div>
        )}

        {type === 'factura' && (
          <div style={{ marginTop:28, display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ borderTop:'1px solid #333', paddingTop:8, fontSize:12, color:'#555', marginTop:50 }}>Recibí conforme</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ borderTop:'1px solid #333', paddingTop:8, fontSize:12, color:'#555', marginTop:50 }}>Revisado por</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ borderTop:'1px solid #333', paddingTop:8, fontSize:12, color:'#555', marginTop:50 }}>Entregado por</div>
            </div>
          </div>
        )}
        {type === 'factura' && (
          <div style={{ marginTop:24, padding:'14px', background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, fontSize:12, color:'#333' }}>
            <div style={{ fontWeight:800, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>GARANTÍA Y ATENCIÓN AL CLIENTE</div>
            <p style={{ margin:'0 0 8px', lineHeight:1.6 }}>Este producto cuenta con garantía por defectos de fabricación. La garantía no cubre daños por mal uso, humedad, golpes, manchas, rasgaduras, quemaduras, daños por mascotas, exposición al sol o lluvia, traslado incorrecto, modificaciones de terceros o desgaste normal por uso.</p>
            <p style={{ margin:0, lineHeight:1.6 }}>Para consultas comunicarse con: <strong style={{ color:'#5c3d2e' }}>Muebles Terrasol — Tel: 7136-8383 / 7166-6393</strong></p>
          </div>
        )}

        {order.observations && (
          <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:12, fontSize:13, marginTop:12 }}>
            <strong>📝 Observaciones:</strong> {order.observations}
          </div>
        )}

        

        <div style={{ display:'flex', gap:10, marginTop:20 }} className="no-print">
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600 }} onClick={handlePrint}>🖨️ Imprimir</button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14 }} onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

const emptyItem = () => ({ articulo: '', descripcion: '', cantidad: 1, precio_unitario: '' });

function EditOrderModal({ order, items: initialItems, onClose, onSaved }) {
  const [form, setForm] = useState({
    nombre: order.cliente_nombre || '',
    cedula: order.cedula || '',
    email: order.email || '',
    direccion: order.address || '',
    tel1: order.phone1 || '',
    tel2: order.phone2 || '',
    fechaOrden: fmtFecha(order.order_date) || '',
    fechaEntrega: fmtFecha(order.delivery_date) || '',
    envio: Math.round(order.shipping || 0),
    observaciones: order.observations || '',
  });
  const [items, setItems] = useState(
    initialItems && initialItems.length > 0
      ? initialItems.map(i => ({ articulo: i.articulo, descripcion: i.descripcion||'', cantidad: i.cantidad, precio_unitario: i.precio_unitario, tipo: i.tipo||'', tela_catalogo: i.tela_catalogo||'', tela_codigo: i.tela_codigo||'' }))
      : [emptyItem()]
  );
  const [catalog, setCatalog] = useState([]);
  const [showCatalog, setShowCatalog] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    inventoryService.getProducts().then(res => setCatalog(res.data)).catch(() => {});
  }, []);

  const set = k => e => setForm(p => ({...p, [k]: e.target.value}));
  const setItem = (idx, k) => e => setItems(prev => prev.map((item, i) => i === idx ? { ...item, [k]: e.target.value } : item));
  const addItem = () => setItems(prev => [...prev, emptyItem()]);
  const removeItem = idx => setItems(prev => prev.filter((_, i) => i !== idx));
  const selectFromCatalog = (idx, prod, vari) => {
    setItems(prev => prev.map((item, i) => i === idx ? { ...item, articulo: `${prod.name} - ${vari.nombre}`, precio_unitario: vari.precio } : item));
    setShowCatalog(null);
  };

  const totalItems = items.reduce((sum, item) => sum + (Number(item.cantidad) * Number(item.precio_unitario || 0)), 0);
  const totalGeneral = totalItems + Number(form.envio || 0);

  const handleSave = async () => {
    if (!form.nombre || !form.direccion || !form.tel1) { alert('Completa los campos obligatorios'); return; }
    for (let item of items) {
      if (!item.articulo || !item.precio_unitario || !item.cantidad) { alert('Completa todos los campos de cada artículo'); return; }
    }
    setLoading(true);
    try {
      const res = await orderService.update(order.id, { ...form, items });
      onSaved(res.data);
    } catch (err) {
      alert('Error al guardar cambios');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 },
    box: { background:'#fff', borderRadius:12, padding:26, maxWidth:620, width:'90%', maxHeight:'90vh', overflowY:'auto' },
    label: { display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' },
    input: { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12 },
    grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0 14px' },
    textarea: { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12, resize:'vertical', minHeight:60 },
    opt: { fontSize:11, color:'#aaa', fontWeight:400, marginLeft:4 },
    itemRow: { background:'#fdf8f4', border:'1px solid #e8ddd4', borderRadius:8, padding:14, marginBottom:10 },
    btnGhost: { background:'transparent', color:'#5c3d2e', border:'1px solid #d0b89a', padding:'5px 10px', borderRadius:6, cursor:'pointer', fontSize:11 },
    btnRemove: { background:'#fee2e2', color:'#ef4444', border:'none', padding:'5px 8px', borderRadius:6, cursor:'pointer', fontSize:11 },
    btnAdd: { background:'#f0fdf4', color:'#10b981', border:'1px dashed #10b981', padding:'8px 16px', borderRadius:7, cursor:'pointer', fontSize:13, width:'100%', marginTop:4 },
    totalBox: { background:'#5c3d2e', color:'#fff', borderRadius:8, padding:'12px 16px', marginTop:10 },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.box} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 16px', color:'#5c3d2e' }}>✏️ Editar Orden — {order.numero}</h3>
        <div style={s.grid2}>
          <div><label style={s.label}>Fecha Orden</label><input style={s.input} type="date" value={form.fechaOrden} onChange={set('fechaOrden')}/></div>
          <div><label style={s.label}>Fecha Entrega</label><input style={s.input} type="date" value={form.fechaEntrega} onChange={set('fechaEntrega')}/></div>
        </div>
        <label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={set('nombre')}/>
        <div style={s.grid2}>
          <div><label style={s.label}>Cédula <span style={s.opt}>(opcional)</span></label><input style={s.input} value={form.cedula} onChange={set('cedula')}/></div>
          <div><label style={s.label}>Correo <span style={s.opt}>(opcional)</span></label><input style={s.input} type="email" value={form.email} onChange={set('email')}/></div>
        </div>
        <div style={s.grid2}>
          <div><label style={s.label}>Teléfono 1 *</label><input style={s.input} value={form.tel1} onChange={set('tel1')}/></div>
          <div><label style={s.label}>Teléfono 2 <span style={s.opt}>(opcional)</span></label><input style={s.input} value={form.tel2} onChange={set('tel2')}/></div>
        </div>
        <label style={s.label}>Dirección *</label><input style={s.input} value={form.direccion} onChange={set('direccion')}/>

        <div style={{ fontWeight:700, fontSize:14, color:'#5c3d2e', margin:'16px 0 10px' }}>📦 Artículos</div>
        {items.map((item, idx) => (
          <div key={idx} style={s.itemRow}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
              <span style={{ fontWeight:600, fontSize:12, color:'#5c3d2e' }}>Artículo {idx+1}</span>
              <div style={{ display:'flex', gap:6 }}>
                <button style={s.btnGhost} onClick={() => setShowCatalog(showCatalog === idx ? null : idx)}>🔍 Catálogo</button>
                {items.length > 1 && <button style={s.btnRemove} onClick={() => removeItem(idx)}>✕</button>}
              </div>
            </div>
            {showCatalog === idx && (
              <div style={{ background:'#fff', border:'1px solid #e0d0c0', borderRadius:7, padding:10, marginBottom:8 }}>
                {catalog.map(prod => (
                  <div key={prod.id} style={{ marginBottom:6 }}>
                    <div style={{ fontWeight:600, fontSize:12, color:'#5c3d2e', marginBottom:3 }}>{prod.name}</div>
                    <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                      {prod.variantes?.map(v => (
                        <button key={v.id} onClick={() => selectFromCatalog(idx, prod, v)}
                          style={{ background:'#f0fdf4', border:'1px solid #ddd', borderRadius:5, padding:'4px 8px', cursor:'pointer', fontSize:11 }}>
                          {v.nombre} — ₡{Number(v.precio).toLocaleString('es-CR')}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <label style={s.label}>Tipo de mueble</label>
            <select style={s.input} value={item.tipo||''} onChange={setItem(idx, 'tipo')}>
              <option value="">— Seleccionar tipo —</option>
              {TIPOS_MUEBLE.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
            {item.tipo && !TIPOS_SIN_TELA.includes(item.tipo) && (
              <div style={s.grid2}>
                <div><label style={s.label}>Catálogo de tela</label><input style={s.input} placeholder="Ej: Tokio" value={item.tela_catalogo||''} onChange={setItem(idx, 'tela_catalogo')} /></div>
                <div><label style={s.label}>Código de tela</label><input style={s.input} placeholder="Ej: 4521" value={item.tela_codigo||''} onChange={setItem(idx, 'tela_codigo')} /></div>
              </div>
            )}
            <label style={s.label}>Artículo *</label>
            <input style={s.input} value={item.articulo} onChange={setItem(idx, 'articulo')}/>
            <label style={s.label}>Descripción</label>
            <input style={s.input} placeholder="Color, medidas, acabado..." value={item.descripcion} onChange={setItem(idx, 'descripcion')}/>
            <div style={s.grid2}>
              <div><label style={s.label}>Cantidad *</label><input style={s.input} type="number" min="1" value={item.cantidad} onChange={setItem(idx, 'cantidad')}/></div>
              <div><label style={s.label}>Precio unitario (₡) *</label><input style={s.input} type="number" value={item.precio_unitario} onChange={setItem(idx, 'precio_unitario')}/></div>
            </div>
            {item.precio_unitario && item.cantidad && (
              <div style={{ textAlign:'right', fontSize:12, color:'#5c3d2e', fontWeight:600 }}>
                Subtotal: {fmt(Number(item.cantidad) * Number(item.precio_unitario))}
              </div>
            )}
          </div>
        ))}
        <button style={s.btnAdd} onClick={addItem}>+ Agregar otro artículo</button>

        <div style={s.grid2}>
          <div style={{ marginTop:12 }}><label style={s.label}>Flete (₡)</label><input style={s.input} type="number" value={form.envio} onChange={set('envio')}/></div>
          <div></div>
        </div>
        <div style={s.totalBox}>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, opacity:0.85, marginBottom:4 }}><span>Subtotal</span><span>{fmt(totalItems)}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, opacity:0.85, marginBottom:8 }}><span>Flete</span><span>{fmt(Number(form.envio||0))}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:16, fontWeight:700, borderTop:'1px solid rgba(255,255,255,0.3)', paddingTop:8 }}><span>TOTAL</span><span>{fmt(totalGeneral)}</span></div>
        </div>

        <label style={{ ...s.label, marginTop:12 }}>Observaciones</label>
        <textarea style={s.textarea} value={form.observaciones} onChange={set('observaciones')}/>

        <div style={{ display:'flex', gap:10, marginTop:8 }}>
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 24px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, opacity:loading?0.7:1 }} onClick={handleSave} disabled={loading}>
            {loading ? 'Guardando...' : '✅ Guardar Cambios'}
          </button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function AnularModal({ order, onClose, onAnulada }) {
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAnular = async () => {
    if (!motivo.trim()) { alert('Debes escribir el motivo de anulación'); return; }
    setLoading(true);
    try {
      await orderService.anular(order.id, motivo.trim());
      onAnulada();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al anular la orden');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 },
    box: { background:'#fff', borderRadius:12, padding:26, maxWidth:440, width:'90%' },
    label: { display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' },
    textarea: { width:'100%', padding:'10px 12px', border:'2px solid #ef4444', borderRadius:7, fontSize:14, boxSizing:'border-box', resize:'vertical', minHeight:80, outline:'none' },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.box} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 8px', color:'#ef4444' }}>🚫 Anular Orden — {order.numero}</h3>
        <p style={{ fontSize:13, color:'#666', margin:'0 0 16px' }}>Esta acción no se puede deshacer.</p>
        <label style={s.label}>Motivo de anulación *</label>
        <textarea style={s.textarea} placeholder="Escribe el motivo..." value={motivo} onChange={e=>setMotivo(e.target.value)}/>
        <div style={{ display:'flex', gap:10, marginTop:16 }}>
          <button style={{ background:'#ef4444', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, opacity:loading?0.7:1, flex:1 }} onClick={handleAnular} disabled={loading}>
            {loading ? 'Anulando...' : '🚫 Confirmar Anulación'}
          </button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function PhotosSection({ orderId, onPhotosLoaded }) {
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    loadPhotos();
  }, []);

  const loadPhotos = async () => {
    try {
      const res = await axios.get(`/api/orders/${orderId}/photos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPhotos(res.data);
      if (onPhotosLoaded) onPhotosLoaded(res.data);
    } catch {}
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      await axios.post(`/api/orders/${orderId}/photos`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      await loadPhotos();
    } catch {
      alert('Error al subir la foto');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (photoId) => {
    if (!window.confirm('¿Eliminar esta foto?')) return;
    try {
      await axios.delete(`/api/orders/${orderId}/photos/${photoId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const updated = photos.filter(p => p.id !== photoId);
      setPhotos(updated);
      if (onPhotosLoaded) onPhotosLoaded(updated);
    } catch {
      alert('Error al eliminar la foto');
    }
  };

  return (
    <div style={{ marginTop:12, border:'1px solid #e8ddd4', borderRadius:8, overflow:'hidden' }} className="no-print">
      <div
        onClick={() => setExpanded(p => !p)}
        style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 14px', background:'#fdf8f4', cursor:'pointer' }}
      >
        <div style={{ fontWeight:600, fontSize:13, color:'#5c3d2e' }}>
          📷 Fotos de referencia {photos.length > 0 ? `(${photos.length})` : ''}
        </div>
        <span style={{ fontSize:12, color:'#aaa' }}>{expanded ? '▲ Ocultar' : '▼ Ver fotos'}</span>
      </div>

      {expanded && (
        <div style={{ padding:14 }}>
          {photos.length === 0 && (
            <div style={{ textAlign:'center', color:'#aaa', fontSize:13, padding:'12px 0' }}>No hay fotos agregadas</div>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:8, marginBottom: photos.length > 0 ? 12 : 0 }}>
            {photos.map(photo => (
              <div key={photo.id} style={{ position:'relative' }}>
                <img
                  src={`/uploads/orders/${photo.filename}`}
                  alt="Referencia"
                  onClick={() => setLightbox(`/uploads/orders/${photo.filename}`)}
                  style={{ width:'100%', height:90, objectFit:'cover', borderRadius:6, cursor:'pointer', border:'1px solid #e8ddd4' }}
                />
                <button
                  onClick={() => handleDelete(photo.id)}
                  style={{ position:'absolute', top:3, right:3, background:'rgba(239,68,68,0.85)', color:'#fff', border:'none', borderRadius:'50%', width:20, height:20, cursor:'pointer', fontSize:11, display:'flex', alignItems:'center', justifyContent:'center', padding:0 }}
                >✕</button>
              </div>
            ))}
          </div>
          <label style={{ display:'inline-block', background: uploading ? '#aaa' : '#5c3d2e', color:'#fff', padding:'7px 14px', borderRadius:7, cursor: uploading ? 'not-allowed' : 'pointer', fontSize:12, fontWeight:600 }}>
            {uploading ? '⏳ Subiendo...' : '+ Agregar foto'}
            <input type="file" accept="image/*" style={{ display:'none' }} onChange={handleUpload} disabled={uploading}/>
          </label>
        </div>
      )}

      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, cursor:'pointer' }}>
          <img src={lightbox} alt="Foto" style={{ maxWidth:'90%', maxHeight:'90vh', borderRadius:8, objectFit:'contain' }}/>
        </div>
      )}
    </div>
  );
}

const METODOS_ABONO = ['Efectivo', 'Tarjeta', 'Deposito', 'SINPE', 'Transferencia', 'Tasa Cero', 'Minicuotas'];
function AbonoModal({ order, saldo, onClose, onGuardado }) {
  const [monto, setMonto] = useState('');
  const [metodo, setMetodo] = useState('Efectivo');
  const [nota, setNota] = useState('');
  const [loading, setLoading] = useState(false);
  const guardar = async () => {
    const m = Number(monto);
    if (!m || m <= 0) { alert('Ingrese un monto válido'); return; }
    if (m > saldo) { alert('El abono no puede superar el saldo pendiente ('+new Intl.NumberFormat('es-CR',{style:'currency',currency:'CRC',maximumFractionDigits:0}).format(saldo)+')'); return; }
    setLoading(true);
    try {
      await abonoService.crear(order.id, m, metodo, nota || null);
      onGuardado();
    } catch (e) { alert(e.response?.data?.error || 'Error al registrar el abono'); }
    setLoading(false);
  };
  const fmtC = v => new Intl.NumberFormat('es-CR',{style:'currency',currency:'CRC',maximumFractionDigits:0}).format(v||0);
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200, padding:12 }} onClick={onClose}>
      <div style={{ background:'#fff', borderRadius:12, padding:26, maxWidth:440, width:'100%' }} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 6px', color:'#5c3d2e' }}>💰 Registrar abono — {order.numero}</h3>
        <p style={{ fontSize:13, color:'#666', margin:'0 0 4px' }}>Cliente: <strong>{order.cliente_nombre}</strong></p>
        <div style={{ background:'#fef6e9', borderRadius:8, padding:'8px 14px', marginBottom:16, textAlign:'center' }}>
          <span style={{ fontSize:12, color:'#888' }}>Saldo pendiente: </span>
          <strong style={{ color:'#d97706', fontSize:15 }}>{fmtC(saldo)}</strong>
        </div>
        <label style={{ display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' }}>Monto del abono *</label>
        <input type="number" value={monto} onChange={e=>setMonto(e.target.value)} placeholder="0"
          style={{ width:'100%', padding:'10px 12px', border:'2px solid #5c3d2e', borderRadius:7, fontSize:15, boxSizing:'border-box', marginBottom:14, outline:'none' }} />
        <label style={{ display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' }}>Método de pago *</label>
        <select value={metodo} onChange={e=>setMetodo(e.target.value)}
          style={{ width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:14 }}>
          {METODOS_ABONO.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <label style={{ display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' }}>Nota (opcional)</label>
        <input value={nota} onChange={e=>setNota(e.target.value)} placeholder="Ej: abono en oficina"
          style={{ width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:18 }} />
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={guardar} disabled={loading}
            style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'11px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, flex:1, opacity:loading?0.7:1 }}>
            {loading ? 'Guardando...' : 'Registrar abono'}
          </button>
          <button onClick={onClose} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'11px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
export default function OrderDetail({ order, onClose, onStatusChange, onOrderSaved }) {
  const { user } = useAuth();
  const [abonoData, setAbonoData] = useState(null);
  const [mostrarAbonoForm, setMostrarAbonoForm] = useState(false);
  const cargarAbonos = async () => {
    try { const res = await abonoService.listar(order.id); setAbonoData(res.data); }
    catch { setAbonoData(null); }
  };
  useEffect(() => { cargarAbonos(); /* eslint-disable-next-line */ }, [order.id]);
  const [docType, setDocType] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [editing, setEditing] = useState(false);
  const [anulando, setAnulando] = useState(false);
  const [abrirGarantia, setAbrirGarantia] = useState(false);
  const [problemaGarantia, setProblemaGarantia] = useState('');
  const [currentOrder, setCurrentOrder] = useState(order);
  const [items, setItems] = useState([]);
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    const url = configService.getLogoUrl();
    fetch(url).then(r => { if (r.ok) setLogoUrl(url + '?t=' + Date.now()); }).catch(()=>{});
  }, []);

  useEffect(() => {
    orderService.getOne(order.id).then(res => {
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
    }).catch(() => {});
  }, [order.id]);

  const handleSaved = async () => {
    setEditing(false);
    try {
      const res = await orderService.getOne(currentOrder.id);
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
      if (onOrderSaved) onOrderSaved(res.data);
    } catch { setEditing(false); }
  };

  const handleAnulada = async () => {
    setAnulando(false);
    try {
      const res = await orderService.getOne(currentOrder.id);
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
      if (onOrderSaved) onOrderSaved(res.data);
    } catch { onClose(); }
  };

  const handlePrint = () => {
    const el = document.querySelector('.order-detail-print');
    if (!el) return;
    const html = `<html><head><meta charset="utf-8"><style>
      body{font-family:Arial,sans-serif;font-size:13px;padding:20mm;margin:0;}
      .row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #f0e8e0;font-size:15px;}
      table{width:100%;border-collapse:collapse;}
      th{background:#f5ede6;padding:7px 10px;text-align:left;font-weight:700;font-size:12px;color:#5c3d2e;border-bottom:2px solid #e0d0c0;}
      td{padding:8px 10px;border-bottom:1px solid #f0e8e0;font-size:13px;vertical-align:top;}
      .no-print{display:none!important;}
      .firmas{display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:60px;}
      .firma-linea{border-top:1px solid #333;padding-top:8px;font-size:12px;color:#555;text-align:center;margin-top:50px;}
      @page{margin:0;size:A4;}
    </style></head><body>${el.innerHTML}</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const puedeEditar = (user.role === 'admin' || currentOrder.user_id === user.id);
  const puedeAnular = currentOrder.status !== 'Anulada' && puedeEditar;

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
    box: { background: currentOrder.status === 'Anulada' ? '#f9f9f9' : '#fff', borderRadius:12, padding:26, maxWidth:560, width:'90%', maxHeight:'88vh', overflowY:'auto', border: currentOrder.status === 'Anulada' ? '2px solid #e5e7eb' : 'none' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
    badge: est => ({ background:COLORS[est]||'#aaa', color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600, display:'inline-block' }),
    docBtn: c => ({ background:c, color:'#fff', border:'none', padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600, marginRight:4 }),
    th: { background:'#f5ede6', padding:'7px 10px', textAlign:'left', fontWeight:700, fontSize:12, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0' },
    td: { padding:'8px 10px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'top' },
  };

  const o = currentOrder;

  if (docType) return <DocView order={o} items={items} type={docType} onClose={()=>setDocType(null)} logoUrl={logoUrl} photos={photos}/>;
  if (editing) return <EditOrderModal order={o} items={items} onClose={()=>setEditing(false)} onSaved={handleSaved}/>;
  if (anulando) return <AnularModal order={o} onClose={()=>setAnulando(false)} onAnulada={handleAnulada}/>

  const handleCrearGarantia = async () => {
    if (!problemaGarantia.trim()) { alert('Describe el problema'); return; }
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/garantias', { method:'POST', headers:{ Authorization: `Bearer ${token}`, 'Content-Type':'application/json' }, body: JSON.stringify({ order_id: o.id, problema: problemaGarantia }) });
      if (!res.ok) throw new Error('Error');
      setAbrirGarantia(false);
      setProblemaGarantia('');
      alert('Garantia abierta correctamente');
    } catch { alert('Error al abrir garantia'); }
  };

  if (abrirGarantia) return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 }} onClick={()=>setAbrirGarantia(false)}>
      <div style={{ background:'#fff', borderRadius:12, padding:28, maxWidth:480, width:'90%' }} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 8px', color:'#5c3d2e' }}>🛡️ Abrir Garantia — {o.numero}</h3>
        <p style={{ fontSize:13, color:'#666', margin:'0 0 16px' }}>Cliente: <strong>{o.cliente_nombre}</strong></p>
        <label style={{ display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' }}>Describe el problema *</label>
        <textarea value={problemaGarantia} onChange={e=>setProblemaGarantia(e.target.value)} placeholder='Describe el problema reportado por el cliente...' style={{ width:'100%', padding:'10px 12px', border:'2px solid #f59e0b', borderRadius:7, fontSize:14, boxSizing:'border-box', resize:'vertical', minHeight:100, outline:'none', marginBottom:16 }}/>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={handleCrearGarantia} style={{ background:'#f59e0b', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, flex:1 }}>Abrir Caso</button>
          <button onClick={()=>setAbrirGarantia(false)} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }}>Cancelar</button>
        </div>
      </div>
    </div>
  );;
  if (mostrarAbonoForm && abonoData) return (
    <AbonoModal order={o} saldo={abonoData.saldo} onClose={()=>setMostrarAbonoForm(false)} onGuardado={()=>{ setMostrarAbonoForm(false); cargarAbonos(); }} />
  );

  return (
    <>
      <style>{printStyles}</style>
      <div style={s.overlay} onClick={onClose}>
        <div style={s.box} className="order-detail-print" onClick={e=>e.stopPropagation()}>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
            <div>
              <span style={s.badge(o.status)}>{o.status}</span>
              <div style={{ fontSize:12, color:'#aaa', marginTop:6 }}>Vendedor: {o.vendedor}</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontWeight:900, fontSize:28, color: o.status==='Anulada'?'#9ca3af':'#5c3d2e', lineHeight:1.1 }}>{o.numero}</div>
            </div>
          </div>

          {o.status === 'Anulada' && o.motivo_anulacion && (
            <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, marginBottom:14 }}>
              <strong style={{ color:'#ef4444' }}>🚫 Motivo de anulación:</strong> {o.motivo_anulacion}
            </div>
          )}

          {[
            ['Cliente', o.cliente_nombre],
            ['Cédula', o.cedula||'—'],
            ['Correo', o.email||'—'],
            ['Dirección', o.address||'—'],
            ['Tel 1', o.phone1||'—'],
            ['Tel 2', o.phone2||'—'],
            ['Fecha Orden', fmtFecha(o.order_date)],
            ['Fecha Entrega', fmtFecha(o.delivery_date)],
          ].map(([l,v]) => (
            <div key={l} style={s.row}><span style={{ color:'#888', fontWeight:600 }}>{l}</span><span style={{ fontWeight:600 }}>{v}</span></div>
          ))}

          {items.length > 0 && (
            <div style={{ marginTop:14 }}>
              <div style={{ fontWeight:700, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>📦 ARTÍCULOS:</div>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr>
                    <th style={s.th}>Artículo / Descripción</th>
                    <th style={{ ...s.th, textAlign:'center' }}>Cant.</th>
                    <th style={{ ...s.th, textAlign:'right' }}>P. Unit.</th>
                    <th style={{ ...s.th, textAlign:'right' }}>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, idx) => (
                    <tr key={idx}>
                      <td style={s.td}>
                        <div style={{ fontWeight:600 }}>{item.articulo}</div>
                        {(item.tipo || item.tela_catalogo) && <div style={{ color:'#5c3d2e', fontSize:12, marginTop:2 }}>{item.tipo ? 'Tipo: ' + item.tipo : ''}{item.tipo && item.tela_catalogo ? ' · ' : ''}{item.tela_catalogo ? 'Tela: ' + item.tela_catalogo + (item.tela_codigo ? ' (' + item.tela_codigo + ')' : '') : ''}</div>}
                        {item.descripcion && <div style={{ color:'#888', fontSize:12, marginTop:2 }}>{item.descripcion}</div>}
                      </td>
                      <td style={{ ...s.td, textAlign:'center' }}>{item.cantidad}</td>
                      <td style={{ ...s.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>
                      <td style={{ ...s.td, textAlign:'right', fontWeight:600 }}>{fmt(item.subtotal)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div style={{ marginTop:10 }}>
            <div style={s.row}><span style={{ color:'#888', fontWeight:600 }}>Subtotal artículos</span><span style={{ fontWeight:600 }}>{fmt(o.amount)}</span></div>
            <div style={s.row}><span style={{ color:'#888', fontWeight:600 }}>Envío</span><span style={{ fontWeight:600 }}>{fmt(o.shipping)}</span></div>
            <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0', fontSize:15, fontWeight:800, color:'#5c3d2e', borderTop:'2px solid #5c3d2e', marginTop:4 }}>
              <span>TOTAL</span><span>{fmt(Number(o.amount)+Number(o.shipping))}</span>
            </div>
          </div>

          {o.observations && (
            <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:10, fontSize:13, marginTop:10 }}>
              <strong>📝 Observaciones:</strong> {o.observations}
            </div>
          )}

          {/* Sección de fotos */}
          <PhotosSection orderId={o.id} onPhotosLoaded={setPhotos} />

          {/* Firmas */}
          <div className="firmas" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:40, marginTop:40 }}>
            <div style={{ textAlign:'center' }}>
              <div className="firma-linea" style={{ borderTop:'1px solid #333', paddingTop:8, fontSize:12, color:'#555', marginTop:50 }}>Repartidor</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div className="firma-linea" style={{ borderTop:'1px solid #333', paddingTop:8, fontSize:12, color:'#555', marginTop:50 }}>Revisado por</div>
            </div>
          </div>

          {user.role === 'admin' && o.status !== 'Anulada' && (
            <div style={{ marginTop:14 }} className="no-print">
              <label style={{ display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' }}>Cambiar Estado:</label>
              <select style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:7, fontSize:14 }}
                value={o.status} onChange={e=>{ onStatusChange(o.id, e.target.value); setCurrentOrder(p=>({...p,status:e.target.value})); }}>
                {ESTADOS.map(est=><option key={est}>{est}</option>)}
              </select>
            </div>
          )}

          {abonoData && (
            <div style={{ marginTop:16, paddingTop:14, borderTop:'1px solid #f0e8e0' }} className="no-print">
              <div style={{ fontSize:13, color:'#5c3d2e', marginBottom:10, fontWeight:700 }}>💰 Abonos y saldo</div>
              <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:10 }}>
                <div style={{ background:'#f8f5f0', borderRadius:8, padding:'8px 14px', flex:1, minWidth:100 }}>
                  <div style={{ fontSize:11, color:'#888' }}>Total</div>
                  <div style={{ fontSize:15, fontWeight:700, color:'#5c3d2e' }}>{fmt(abonoData.total)}</div>
                </div>
                <div style={{ background:'#f0f7f0', borderRadius:8, padding:'8px 14px', flex:1, minWidth:100 }}>
                  <div style={{ fontSize:11, color:'#888' }}>Abonado</div>
                  <div style={{ fontSize:15, fontWeight:700, color:'#3a7d44' }}>{fmt(abonoData.abonado)}</div>
                </div>
                <div style={{ background: abonoData.saldo <= 0 ? '#f0f7f0' : '#fef6e9', borderRadius:8, padding:'8px 14px', flex:1, minWidth:100 }}>
                  <div style={{ fontSize:11, color:'#888' }}>Saldo pendiente</div>
                  <div style={{ fontSize:15, fontWeight:800, color: abonoData.saldo <= 0 ? '#3a7d44' : '#d97706' }}>{fmt(abonoData.saldo)}</div>
                </div>
              </div>
              {abonoData.abonos.length > 0 && (
                <div style={{ marginBottom:8 }}>
                  {abonoData.abonos.map(a => (
                    <div key={a.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 10px', background:'#faf7f3', borderRadius:6, marginBottom:4, fontSize:12 }}>
                      <span><strong>{fmt(a.monto)}</strong> · {a.metodo} · {fmtFecha(a.created_at)} · <span style={{ color:'#888' }}>{a.registrado_por_nombre||'—'}</span>{a.nota ? ' · '+a.nota : ''}</span>
                      {[1,2,3].includes(user.id) && (
                        <button onClick={async()=>{ if(window.confirm('¿Eliminar este abono?')){ try{ await abonoService.eliminar(a.id); cargarAbonos(); }catch(e){ alert(e.response?.data?.error||'Error'); } } }}
                          style={{ background:'#fee', color:'#c00', border:'none', borderRadius:5, width:26, height:26, cursor:'pointer', fontSize:13 }}>🗑️</button>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {[1,2,3].includes(user.id) && o.status !== 'Anulada' && abonoData.saldo > 0 && (
                <button onClick={()=>setMostrarAbonoForm(true)}
                  style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'8px 14px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>
                  + Registrar abono
                </button>
              )}
            </div>
          )}
          {o.status !== 'Anulada' && (
            <div style={{ marginTop:16, paddingTop:14, borderTop:'1px solid #f0e8e0' }} className="no-print">
              <div style={{ fontSize:12, color:'#888', marginBottom:8, fontWeight:600 }}>GENERAR DOCUMENTOS:</div>
              <button style={s.docBtn('#5c3d2e')} onClick={()=>setDocType('trabajo')}>🔧 Orden Taller</button>
              <button style={s.docBtn('#3b82f6')} onClick={()=>setDocType('entrega')}>🚚 Orden Entrega</button>
              <button style={s.docBtn('#10b981')} onClick={()=>setDocType('factura')}>🧾 Factura</button>
              {o.status === 'Entregada' && <button style={s.docBtn('#f59e0b')} onClick={()=>setAbrirGarantia(true)}>🛡️ Abrir Garantía</button>}
            </div>
          )}

          <div style={{ display:'flex', gap:8, marginTop:14, flexWrap:'wrap' }} className="no-print">
            {o.status !== 'Anulada' && puedeEditar && (
              <button style={{ background:'#f59e0b', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={()=>setEditing(true)}>
                ✏️ Editar
              </button>
            )}
            {puedeAnular && (
              <button style={{ background:'#ef4444', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={()=>setAnulando(true)}>
                🚫 Anular
              </button>
            )}
            <button style={{ background:'#6b7280', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={handlePrint}>
              🖨️ Imprimir
            </button>
            <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
